import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var CooperationQuestRecruitmentModal = function CooperationQuestRecruitmentModal() {
  return import('@/components/organisms/CooperationQuestRecruitmentModal');
};
var UnclosedQuestModal = function UnclosedQuestModal() {
  return import('@/components/organisms/UnclosedQuestModal');
};
var QuestDepartureModal = function QuestDepartureModal() {
  return import('@/components/organisms/QuestDepartureModal');
};
var NodeTypeList = function NodeTypeList() {
  return import('@/components/molecules/NodeTypeList');
};
var QuestTabs = function QuestTabs() {
  return import('@/components/organisms/QuestTabs');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
import Nl2br from 'vue-nl2br';
var LinkedTabs = function LinkedTabs() {
  return import('@/components/organisms/LinkedTabs');
};
var LinkedTabsItem = function LinkedTabsItem() {
  return import('@/components/molecules/LinkedTabsItem');
};
var QuestAutoBattleModal = function QuestAutoBattleModal() {
  return import('@/components/organisms/QuestAutoBattleModal');
};
var BikkuriInfoBox = function BikkuriInfoBox() {
  return import('@/components/molecules/BikkuriInfoBox');
};
var AdventureTypeList = function AdventureTypeList() {
  return import('@/components/molecules/adventure/AdventureTypeList');
};
var UnclosedAdventureModal = function UnclosedAdventureModal() {
  return import('@/components/organisms/adventure/UnclosedAdventureModal');
};
var AdventureRewardModal = function AdventureRewardModal() {
  return import('@/components/organisms/adventure/AdventureRewardModal');
};
var AdventureDepartureModal = function AdventureDepartureModal() {
  return import('@/components/organisms/adventure/AdventureDepartureModal');
};
var AdventureTipsPopupModal = function AdventureTipsPopupModal() {
  return import('@/components/organisms/adventure/AdventureTipsPopupModal');
};
export default {
  components: {
    Modal: Modal,
    UnclosedQuestModal: UnclosedQuestModal,
    QuestDepartureModal: QuestDepartureModal,
    NodeTypeList: NodeTypeList,
    QuestTabs: QuestTabs,
    PageTitle: PageTitle,
    Nl2br: Nl2br,
    CooperationQuestRecruitmentModal: CooperationQuestRecruitmentModal,
    LinkedTabs: LinkedTabs,
    LinkedTabsItem: LinkedTabsItem,
    QuestAutoBattleModal: QuestAutoBattleModal,
    BikkuriInfoBox: BikkuriInfoBox,
    AdventureTypeList: AdventureTypeList,
    UnclosedAdventureModal: UnclosedAdventureModal,
    AdventureRewardModal: AdventureRewardModal,
    AdventureDepartureModal: AdventureDepartureModal,
    AdventureTipsPopupModal: AdventureTipsPopupModal
  },
  data: function data() {
    return {
      currentDepartureNodeType: {},
      selectedNodeTypeInfo: {},
      currentDepartureAdventureType: {},
      selectedAdventureTypeInfo: {},
      isAfterGo: false,
      prevSelectedPartryNo: 0,
      isFinishRecruitModalShown: false,
      isQuestAutoBattleModalShown: false,
      isAdventureTipsPopupModalShown: false,
      fmCount: 0
    };
  },
  computed: {
    me: function me() {
      return useUserStore().me;
    },
    quest: function quest() {
      return useNodeStore().getQuest;
    },
    relatedNodeTypes: function relatedNodeTypes() {
      return useNodeStore().getRelatedNodeTypes;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    isNormalQuest: function isNormalQuest() {
      return this.getQuestType == useQuestStore().getQuestTypes.normalQuest;
    },
    isLandQuest: function isLandQuest() {
      return this.getQuestType == useQuestStore().getQuestTypes.landQuest;
    },
    getQuestType: function getQuestType() {
      if (this.$route.name.includes('event')) {
        return useQuestStore().getQuestTypes.eventQuest;
      } else if (this.$route.query.landQuest) {
        return useQuestStore().getQuestTypes.landQuest;
      } else {
        return useQuestStore().getQuestTypes.normalQuest;
      }
    },
    backPrev: function backPrev() {
      if (this.$route.query.land) {
        return true;
      }
      return false;
    },
    normalNodeTypes: function normalNodeTypes() {
      return useQuestStore().getAdventureTypes;
    },
    landNodeTypes: function landNodeTypes() {
      return useNodeStore().getNodeTypes('land');
    },
    prevNodeInfo: function prevNodeInfo() {
      if (process.server) return {};
      return this.$localStorage.get('prevNodeInfo') || {};
    },
    isUnclosedQuest: function isUnclosedQuest() {
      return useQuestStore().getUnclosedAdventure || !!this.quest && this.quest.status != 6;
    },
    isCooperationQuest: function isCooperationQuest() {
      return !!this.quest && this.quest.status == 6 && !!this.quest.missionId;
    },
    isConsecutiveQuest: function isConsecutiveQuest() {
      return !!this.quest && !!this.quest.consecutiveQuestId;
    },
    questCampainListIds: function questCampainListIds() {
      return [2, 3, 4, 5];
    },
    MyCampaigns: function MyCampaigns() {
      var _this = this;
      var campaigns = useLandMaster().getCampaignDatas;
      var activeLandCampaign = this.$util.clone(this.me.landCampaignsMap);
      var list = [];
      var _loop = function _loop(key) {
        campaigns.forEach(function (c) {
          if (c.landCampaignId == activeLandCampaign[key][0] && _this.questCampainListIds.includes(activeLandCampaign[key][0])) {
            list.push(c);
          }
        });
      };
      for (var key in activeLandCampaign) {
        _loop(key);
      }
      var activeguildCampaign = this.$util.clone(this.me.landguildCampaignsMap);
      var _loop2 = function _loop2(_key) {
        campaigns.forEach(function (c) {
          if (c.landCampaignId == activeguildCampaign[_key][0] && _this.questCampainListIds.includes(activeguildCampaign[_key][0])) {
            if (!list.includes(c)) {
              list.push(c);
            }
          }
        });
      };
      for (var _key in activeguildCampaign) {
        _loop2(_key);
      }
      return list;
    },
    getMissionCounts: function getMissionCounts() {
      return useMissionStore().getMissionCounts;
    },
    normalMissionCounts: function normalMissionCounts() {
      return this.getMissionCounts.allNormalCounts ? this.getMissionCounts.allNormalCounts : 0;
    },
    landMissionCounts: function landMissionCounts() {
      return this.getMissionCounts.allLandCounts ? this.getMissionCounts.allLandCounts : 0;
    },
    adventureResult: function adventureResult() {
      return useQuestStore().getAdventureResult;
    },
    isShowTips: function isShowTips() {
      if (!this.adventureResult) return false;
      var adventureType = useQuestStore().getAdventureType(this.adventureResult.adventureType);
      if (!adventureType || adventureType.rarity != 1) return false;
      if (this.adventureResult.clearStages == adventureType.adventureStagesList.length) return false;
      return true;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this2.isLoggedIn) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (_this2.isShowTips) _this2.isAdventureTipsPopupModalShown = true;
            _context.next = 5;
            return useNodeStore().fetchNodes();
          case 5:
            _context.next = 7;
            return useNodeStore().checkUnclosedQuest();
          case 7:
            _context.next = 9;
            return useQuestStore().fetchCurrentAdventureTypes();
          case 9:
            _context.next = 11;
            return useQuestStore().checkUnclosedAdventure();
          case 11:
            if (!_this2.isNormalQuest) _this2.initCurrentDepartureNode();
            if (_this2.$localStorage.get('prevTemplateNo')) {
              if (!isNaN(Number(_this2.$localStorage.get('prevTemplateNo')))) {
                _this2.prevSelectedPartryNo = Number(_this2.$localStorage.get('prevTemplateNo'));
              }
            }
            _context.next = 15;
            return _this2.fetchMyOwnLandSectorIds();
          case 15:
            _context.next = 17;
            return _this2.fetchMyOwnLandSectors();
          case 17:
            _context.next = 19;
            return _this2.fetchMyOwnRelatedLands();
          case 19:
            _context.next = 21;
            return useMissionStore().fetchMissionCounts({
              isFull: false,
              cooperationType: 2,
              targetType: [],
              lvs: []
            });
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    fetchMyOwnRelatedLands: function fetchMyOwnRelatedLands() {
      return useLandStore().fetchMyOwnRelatedLands();
    },
    fetchMyOwnLandSectorIds: function fetchMyOwnLandSectorIds() {
      return useLandStore().fetchMyOwnLandSectorIds();
    },
    fetchMyOwnLandSectors: function fetchMyOwnLandSectors() {
      return useLandStore().fetchMyOwnLandSectors();
    },
    getPrevNodeId: function getPrevNodeId(nodeType) {
      return this.prevNodeInfo[nodeType] || 0;
    },
    afterGo: function afterGo(battleIds) {
      this.isAfterGo = true;
      this.$router.push(this.localePath({
        path: "/battle",
        query: {
          qbhash: battleIds.join('_'),
          type: this.isNormalQuest
        }
      }));
    },
    refetchNode: function refetchNode() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return useNodeStore().fetchNodes();
            case 2:
              _this3.currentDepartureNodeType = useNodeStore().getNodeTypes(_this3.isNormalQuest ? 'normal' : 'land').find(function (node) {
                return node.nodeType == _this3.currentDepartureNodeType.nodeType;
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    initCurrentDepartureNode: function initCurrentDepartureNode() {
      if (this.isConsecutiveQuest || this.$localStorage.get('consecutivePrev')) {
        var id = this.isConsecutiveQuest ? this.quest.nodeId : Number(this.$localStorage.get('consecutivePrev'));
        var current;
        this.normalNodeTypes.forEach(function (node) {
          var data = node.nodeLvsList.find(function (x) {
            return x.nodeId == id;
          });
          if (data) current = node;
        });
        this.currentDepartureNodeType = current;
        this.isQuestAutoBattleModalShown = true;
        this.$localStorage.set('consecutivePrev', null);
      }
      if (this.$localStorage.get('prevNodeType') || this.$localStorage.get('prevAdventureType')) {
        if (this.$route.query.departureModal) {
          for (var i = 0; i < this.normalNodeTypes.length; i++) {
            if (this.isNormalQuest && this.$localStorage.get('prevAdventureType') && this.normalNodeTypes[i].adventureType == this.$localStorage.get('prevAdventureType').adventureType) {
              this.currentDepartureAdventureType = this.normalNodeTypes[i];
            }
          }
          for (var _i = 0; _i < this.landNodeTypes.length; _i++) {
            if (!this.isNormalQuest && this.$localStorage.get('prevNodeType') && this.landNodeTypes[_i].nodeType == this.$localStorage.get('prevNodeType').nodeType) {
              this.currentDepartureNodeType = this.landNodeTypes[_i];
            }
          }
        }
        this.$localStorage.set('prevNodeType', null);
        this.$localStorage.set('prevAdventureType', null);
      }
    },
    adventureResultViewed: function adventureResultViewed() {
      useQuestStore().setAdventureResultViewed();
      this.initCurrentDepartureNode();
    }
  }
};